<frog-landing-toolbar></frog-landing-toolbar>
<div class="flex row align-space-between justify-center root">
    <div></div>
    @if (client$ | async; as client) {
        <div class="flex-80">
            <form [formGroup]="form" class="flex row justify-space-between">
                <div class="flex-66">
                    <mat-card appearance="outlined">
                        <mat-card-header>
                            <mat-card-title>Upgrade Your Subscription</mat-card-title>
                            <mat-card-subtitle>{{ client.config.data.name }}</mat-card-subtitle>
                        </mat-card-header>
                        <mat-card-content>
                            <div class="flex column">
                                <mat-list>
                                    <mat-list-item>
                                        <mat-icon
                                            matListItemIcon
                                            fontSet="material-icons-outlined"
                                            class="primary"
                                            >check</mat-icon
                                        >
                                        Users can be added as needed and will be prorated
                                    </mat-list-item>
                                    <mat-list-item>
                                        <mat-icon
                                            matListItemIcon
                                            fontSet="material-icons-outlined"
                                            class="primary"
                                            >check</mat-icon
                                        >
                                        50gb Storage included and can be upgradable as you grow
                                    </mat-list-item>
                                    <mat-list-item>
                                        <mat-icon
                                            matListItemIcon
                                            fontSet="material-icons-outlined"
                                            class="primary"
                                            >check</mat-icon
                                        >
                                        Unlimited uploads and file sizes
                                    </mat-list-item>
                                </mat-list>
                            </div>
                            <mat-divider></mat-divider>
                            @if (pricing$ | async; as pricing) {
                                <div>
                                    <mat-radio-group formControlName="interval">
                                        <div class="flex row">
                                            <div class="flex column flex-10">
                                                <mat-radio-button value="month"></mat-radio-button>
                                            </div>
                                            <div class="flex column flex-60">
                                                <h2>Monthly</h2>
                                                <p>Month-to-month contract</p>
                                            </div>
                                            <div class="flex column flex-20">
                                                <p>Per Month</p>
                                                <h1>
                                                    {{
                                                        pricing.monthly / 100.0
                                                            | currency: "USD" : "symbol" : "1.0"
                                                    }}/user
                                                </h1>
                                            </div>
                                        </div>
                                        <mat-divider></mat-divider>
                                        <div class="flex row">
                                            <div class="flex column flex-10">
                                                <mat-radio-button value="annual"></mat-radio-button>
                                            </div>
                                            <div class="flex column flex-60">
                                                <h2>Annually</h2>
                                                <p>
                                                    Get 2 months free (17% off) by committing to a
                                                    12-month plan
                                                </p>
                                            </div>
                                            <div class="flex column flex-20">
                                                <p>Per Year</p>
                                                <h1>
                                                    {{
                                                        pricing.annual / 100.0
                                                            | currency: "USD" : "symbol" : "1.0"
                                                    }}/user
                                                </h1>
                                            </div>
                                        </div>
                                    </mat-radio-group>
                                </div>
                            }
                        </mat-card-content>
                    </mat-card>
                </div>
                <div class="flex-32">
                    <div class="flex column">
                        <!-- Total -->
                        <mat-card appearance="outlined">
                            <mat-card-content>
                                <h2 class="flex align-center justify-center">Studio Plan</h2>
                                <mat-divider></mat-divider>
                                <div>
                                    <mat-form-field>
                                        <mat-label>Promo Code</mat-label>
                                        <input matInput [formControl]="promoControl" />
                                    </mat-form-field>
                                    <button mat-button mat-stroked-button (click)="applyPromo()">
                                        Apply
                                    </button>
                                    @if (error) {
                                        <div class="warn">{{ error }}</div>
                                    }
                                </div>
                                <mat-divider></mat-divider>
                                <div class="flex row align-space-around justify-space-between">
                                    <div class="flex column flex-60 total">
                                        <p>Items</p>
                                        <div class="flex align-items-center">
                                            {{ form.value.seats }} <span class="small">Users</span>
                                        </div>
                                    </div>
                                    <div class="total flex-40">
                                        <p>&nbsp;</p>
                                        <div class="flex align-items-center">
                                            <mat-icon>close</mat-icon>
                                            {{ userPrice | currency: "USD" : "symbol" : "1.0" }} /
                                            {{ form.value.interval === "month" ? "mo" : "yr" }}
                                        </div>
                                    </div>
                                </div>
                                @for (member of client.members; track member) {
                                    <div
                                        class="flex row align-space-around justify-space-between small"
                                    >
                                        {{ member.name }}
                                    </div>
                                }
                                <div class="flex row align-space-around justify-space-between">
                                    <div class="flex column flex-60 total">
                                        <div class="flex align-items-center">
                                            50Gb <span class="small">Storage</span>
                                        </div>
                                    </div>
                                    <div class="total flex-40">
                                        <div class="flex align-items-center included">Included</div>
                                    </div>
                                </div>
                                <mat-divider></mat-divider>
                                <div class="flex row align-space-around justify-space-between">
                                    <div class="flex column flex-60 total">
                                        <p>Sub Total</p>
                                        <div class="flex align-items-center">&nbsp;</div>
                                    </div>
                                    <div class="total flex-40">
                                        <p>&nbsp;</p>
                                        <div class="flex align-items-center">
                                            {{ subtotal | currency: "USD" : "symbol" : "1.0" }}
                                        </div>
                                    </div>
                                </div>
                                @if (discount) {
                                    <div class="flex row align-space-around justify-space-between">
                                        <div class="flex column flex-60 total">
                                            <div class="flex align-items-center primary">
                                                <mat-icon class="promo-icon">sell</mat-icon>
                                                {{ discount.code }} (%{{ discount.percent_off }}
                                                off)
                                            </div>
                                        </div>
                                        <div class="total flex-40">
                                            <div class="flex align-items-center primary">
                                                -{{
                                                    discount.amount / 100.0
                                                        | currency: "USD" : "symbol" : "1.0"
                                                }}
                                            </div>
                                        </div>
                                    </div>
                                }
                                <mat-divider></mat-divider>
                                <div class="flex row align-center justify-center">
                                    <div class="total-currency">$</div>
                                    <div class="total-value">{{ total | number: "1.0" }}</div>
                                    <div class="total-interval">
                                        /{{ form.value.interval === "month" ? "mo" : "yr" }}
                                    </div>
                                </div>
                                <div class="savings">
                                    Billed
                                    {{ form.value.interval === "month" ? "Monthly" : "Annually" }}
                                </div>
                            </mat-card-content>
                        </mat-card>
                        <div class="pad"></div>
                        <button mat-flat-button color="primary" (click)="submit()">
                            Upgrade Now
                        </button>
                    </div>
                </div>
            </form>
        </div>
    }
    <div></div>
</div>
